<template>
  <div class="app-footer-page">
    <ul>
      <li v-for="item in footerList">
        <p class="flex-middle-x">
          <img v-if="item.image" :src="item.image" alt="">
          <span>{{item.content}}</span>
        </p>
      </li>
    </ul>
  </div>
</template>
<script>
  export default {
    name:'',
    data(){
      return {}
    },
    props:{},
    computed:{
      footerList(){
        return [
          {image:'', content:'沪ICP备17030686号copyright© 2012-2026'},
          {image:'', content:'上海金保证网络科技有限公司版权所有'},
          {image:'', content:'诚信网站'},
          {image:require('./../image/tcp-image.png'), content:'诚信网站'},
          {image:'', content:'网上有害信息举报专区'}
        ]
      }
    }
  }
</script>
<style lang="scss" rel="stylesheet/scss" scoped="">
  .app-footer-page{
    text-align: left;
    padding:0.55rem 0.3rem 0.3rem 0.3rem;
    color:#a6a6a6;
    background:#242424;
    ul{
      li{
        font-size:0.24rem;
        padding-bottom:0.15rem;
        img{
          width:0.3rem;
          padding-right:0.1rem;
        }
      }
    }
  }
</style>
